import React from "react";
import axios from 'axios';

// Axios Cache Instance
import {axiosCached} from "../../redux/auth/authService";

import { axiosDelay } from '../../config/config';

import {
    DATA_SOURCES_UPDATE,
    DATA_SOURCES_ALIAS_UPDATE,
    DATA_SOURCES_FILTER_UPDATE,
    DATA_PORTFOLIO_FILTER_VALUES,
    DATA_SELECTED_PROJECTS_VALUE,
    DATA_DATA_DATE,
    DATA_SOURCES_CANCEL_TOKEN,
    DATA_VIEW_STAGED,
} from "./dataTypes";

import {config} from "@storybook/addon-actions";
import {useSelector} from "react-redux";
import useDataSource from "../../hooks/useDataSource";
import {authStoreToken} from "../auth/authActions";

export const filterUpdateConditionAction = {
    ADD: 'ADD',
    REPLACE: 'REPLACE'
};

const _reloadTimeout = 10;

// function areConfiguredDataSourcesEqual(a, b) {
//     return Array.isArray(a) &&
//         Array.isArray(b) &&
//         a.length === b.length &&
//         a.every((val, index) => val === b[index]);
// }

export function getNestedDataSources(names, components) {

    for (const c of components) {
        if (c?.configuration?.dataSource?.name) {
            names.push(c.configuration.dataSource.name.toLowerCase());
        }

        if (c?.configuration?.components) {
            getNestedDataSources(names, c?.configuration?.components);
        }
    }
}

function getRouteInfo(pathname, pages, activeRoleName){
    let activeRoutes = pathname.substring(1).split('/');
    activeRoutes = activeRoutes.filter(r => r.length > 0);
    if (activeRoutes.length === 0)
        activeRoutes.push("");

    // Determine the active route based on reading the url right to
    // left - the first intersection with a page is the active route
    let activeRoute = null;
    let targetPage = null;
    let tab = '';

    for (let i = activeRoutes.length - 1; i >= 0; i--) {
        let route = activeRoutes[i];
        let pageToFind = route;
        if (route.length === 0) {
            pageToFind = "home";
        }

        // Page exists? Working right to left find the first route part that matches
        // a page - that becomes the active route
        let page = pages.find(p => p.name.toLowerCase() === pageToFind.toLowerCase());

        // Note: if we are not at position 0 then this could be a tab so we need the page at root
        // For example schedule would get picked up with projects/schedule however the route
        // controlling the datasources is projects...
        // In another example task and task\taskreport this logic is correct??
        if (i > 0) {
            const previousPage = pages.find(p => p.name.toLowerCase() === activeRoutes[i - 1]);
            if (previousPage) {
                const tabs = findPageTab(previousPage, activeRoleName);
                if (tabs) {
                    if (tabs.includes(pageToFind)) {
                        page = null;
                    }
                }
            }
        }

        if (page) {

            const tabs = findPageTab(page, activeRoleName);

            if (tabs && i < activeRoutes.length - 1) {
                const possibleTab = activeRoutes[i+1].toLowerCase();
                if (tabs.includes(possibleTab)) {
                    tab = '/{0}'.format(possibleTab);
                }
            }

            // Now that we have the page... was there a tab specification?
            // If so then we need the route to represent the route/tab
            // combination further filtering what data sources will refresh
            // NOTE: Navigation and other sources are not tied to a tab so
            // what do we do with those? Configure all available?

            targetPage = page;
            activeRoute = route.toLowerCase() + tab;

            break;
        } else {
            // console.log('**WARN** No "{0}" page was found in the configuration!'.format(pageToFind));
        }
    }

    return {
        activeRoute: activeRoute,
        page: targetPage
    }
}

function findPageTab(obj, activeRoleName) {
    if (activeRoleName === null) return;

    if (obj?.roles?.length > 0) {
        // Page
        for (let i = 0; i < obj.roles.length; i++) {
            if (obj.roles[i].name.toLowerCase() === activeRoleName.toLowerCase()) {
                const tab = findPageTab(obj.roles[i].configuration);
                if (tab) {
                    const tabs = tab.configuration.tabs.map(t => t.label.toLowerCase());
                    return tabs;
                }
                break;
            }
        }
    } else if (obj?.type?.toLowerCase() == 'tab' && obj?.configuration?.element?.syncRoutes === true) {
        // Component
        return obj;
    } else if (obj?.configuration?.components) {
        // Layout
        for (let c = 0; c < obj.configuration.components.length; c++) {
            const tab = findPageTab(obj.configuration.components[c]);
            if (tab) {
                return tab;
            }
        }
    }


}

function areDataSourcesConfiguredForActiveRole(activeRoleName, roles, dataSourcesUsed) {
    const rolesThatShouldNotBeIncluded = roles.filter(r => r !== activeRoleName);

    // Return false if any data sources reference a role other than active role name
    for (const dsu of dataSourcesUsed) {
        for (const orn of rolesThatShouldNotBeIncluded) {
            if (dsu.toLowerCase().indexOf(orn.toLowerCase()) >= 0) {
                return false;
            }
        }
    }

    return true;
}


export function dataRouteChanged() {
    return (dispatch, getState) => {
        const state = getState();

        const pathname = state.router.location.pathname;
        const config = state.config.data;
		const pages = state.page.pages;
        const activeRoleName = state.persist.activeRoleName ? state.persist.activeRoleName : null;

        if (!config)
            return;

		if (!pages)
			return;

        const routeInfo = getRouteInfo(pathname, pages, activeRoleName);
        if (!routeInfo.page) {
            console.log("**ERROR** No page was configured for the current route");
            return;
        }
        // Find data sources that are configured for the route (all tabs) or route (single tab) i.e. projects or projects/details respectively
        const dataSources = state.data.dataSources.filter((d) => {
            if (d.routes.filter((r) => { if (r.length <= routeInfo.activeRoute.length && r === routeInfo.activeRoute.substring(0, r.length)) return true; }).length > 0) {
                return true;
            }
            return false;
        });

        const role = routeInfo.page?.roles?.find(r => r.name === activeRoleName);

        if (!role && routeInfo.page?.roles) {
            console.log("**ERROR** No role '{0}' was configured for '{1}'".format(activeRoleName, routeInfo.activeRoute !== "" ? routeInfo.activeRoute : "root/home"));
            return;
        }

        // If we have roles defined then validate etc. if not then this is a
        // data page and we simply continue
        // TODO: Validate data route

        const paths = pathname.split('/');
        let isDataLoaderPath = false;
        if (paths.length >= 1 && paths[1].toLowerCase() === "data")
            isDataLoaderPath = true;

        let isSecurityPath = false;
        if (paths.length >= 1 && paths[1].toLowerCase() === "security")
            isSecurityPath = true;

        // HACK: These pages do not follow the same rules however they also
        // manage their own axios calls/data so this should suffice
        if (!isDataLoaderPath && !isSecurityPath) {

            // This is just QA and we don't want to slow down the
            // initial axios calls se we wrap this in a timeout to
            // let the calls fire and then we log

            setTimeout(function() {
                // Get data sources used for configuration, settings, and flip
                let dataSourcesUsed = [];

                const topComponentArray = []
                topComponentArray.push(role.configuration);

                if (role.settingsComponent)
                    topComponentArray.push(role.settingsComponent);

                if (role.flipComponent)
                    topComponentArray.push(role.flipComponent);

                getNestedDataSources(dataSourcesUsed, topComponentArray);

                // Unique Values
                dataSourcesUsed = Array.from(new Set(dataSourcesUsed));

                // Get data sources configured
                let dataSourcesConfigured = dataSources.filter(d => d.routes.includes(routeInfo.activeRoute) && d.roles.includes(activeRoleName)).map(d => d.name.toLowerCase());
                // Unique Values
                dataSourcesConfigured = Array.from(new Set(dataSourcesConfigured));

                // Sync for inclusion i.e. source1,source2 in source1,source2,source3
                dataSourcesUsed.sort();
                dataSourcesConfigured.sort();

                //if (!areConfiguredDataSourcesEqual(dataSourcesUsed, dataSourcesConfigured)) {
                if (dataSourcesConfigured.join(',').indexOf(dataSourcesUsed.join(',')) < 0) {
                    console.log('**WARN** The component referenced datasets on this page do not match the datasets configured for this route:{0}/role:{1}!'.format(routeInfo.activeRoute, activeRoleName));
                    // Remove matches
                    dataSourcesUsed = dataSourcesUsed.filter( function( el ) {
                        return dataSourcesConfigured.indexOf( el ) < 0;
                    } );
                    console.log('Referenced Offenders: {0}'.format(dataSourcesUsed.join(',')));
                    console.log('Configured: {0}'.format(dataSourcesConfigured.join(',')))
                } else {
                    console.log("**Kool&TheGang** Datasets Referenced({0}) vs Configured ({1}) are a match for this route:{2}/role{3}".format(dataSourcesUsed.join(','), dataSourcesConfigured.join(','), routeInfo.activeRoute, activeRoleName));
                }

                if (!areDataSourcesConfiguredForActiveRole(activeRoleName, config.roles, dataSourcesUsed)) {
                    console.log("**ERROR** Datasets from other roles have been referenced ({0})".format(dataSourcesUsed.join(',')));
                }
            }, 0);
        }

        // Refresh datasets that are dirty and tied to this route
        // Delay refresh in the event another change in coming in
        if (window.reloadDataSourcesID) {
            window.clearTimeout(window.reloadDataSourcesID);
        }
        window.reloadDataSourcesID = setTimeout(function () {
            dispatch(_reload());
        }, _reloadTimeout);

        // Example: using DOM onces available
        // Once the dom has rendered let's output the
        // data sources being used and warn if there
        // is anything missing
        // setTimeout(() => {
        //     var elements = [].slice.call(document.querySelectorAll('[data-source]'));
        //
        //     if (elements?.length > 0) {
        //         let dataSourcesUsed = elements.map(e => e.dataset.source);
        //         // Unique Values
        //         dataSourcesUsed = Array.from(new Set(dataSourcesUsed));
        //
        //         let dataSourcesConfigured = dataSources.filter(d => d.routes.includes(activeRoute) && d.roles.includes(roleName)).map(d => d.name);
        //         // Unique Values
        //         dataSourcesConfigured = Array.from(new Set(dataSourcesConfigured));
        //
        //         // Sync for inclusion i.e. source1,source2 in source1,source2,source3
        //         dataSourcesUsed.sort();
        //         dataSourcesConfigured.sort();
        //
        //         //if (!areConfiguredDataSourcesEqual(dataSourcesUsed, dataSourcesConfigured)) {
        //         if (dataSourcesConfigured.join(',').indexOf(dataSourcesUsed.join(',')) < 0) {
        //             console.log('**WARN** The datasets referenced on this page ({0}) do not match what was configured for this route:{1}/role:{2} ({3})!'.format(dataSourcesUsed.join(','), activeRoute, roleName, dataSourcesConfigured.join(',')));
        //         } else {
        //             console.log("**Kool&TheGang** Datasets Referenced({0}) vs Configured ({1})".format(dataSourcesUsed.join(','), dataSourcesConfigured.join(',')));
        //         }
        //     }
        //
        // }, 2000);
    }
}

// TODO: Check for duplicates etc.
export function dataAdd(name, source, fields, aliases, formatters, groupby, orderby, listeners, routes, roles, requireWhereClause, includeInBulkRequest, includeBaselineResults, loadOnStartup, enhanced) {
    return (dispatch, getState) => {
        // console.log('dataActions:add -> ', name, source, fields, groupby, orderby, listeners);

        const state = getState();
        const dataSources = state.data.dataSources;

        dataSources.push({
            name: name,
            source: source,
            fields: fields,
            aliases: aliases,
            formatters: formatters,
            groupby: groupby,
            orderby: orderby,
            listeners: listeners,
            routes: routes,
            roles: roles,
            requireWhereClause: requireWhereClause,
            includeInBulkRequest: includeInBulkRequest,
            includeBaselineResults: includeBaselineResults,
            loadCount: 0,
            fetching: false,
            fetched: false,
            error: null,
            cancelToken: null,
            data: null,
            dirty: loadOnStartup,
            enhanced: enhanced,
            filterState: []
        });

        dispatch({
            type: DATA_SOURCES_UPDATE,
            payload: dataSources
        });
    }
}

export function dataRebuildFieldAliasLookup() {
    return (dispatch, getState) => {
        const state = getState();
        const dataSources = state.data.dataSources;

        const fields = [];
        const alias = [];

        for (const d of dataSources) {
            for (let f = 0; f < d.fields.length; f++) {
                if (typeof d.fields[f] === "object") {
                    let field = d.fields[f].name.toLowerCase();
                    if (field.indexOf(' as ') >= 0) {
                        field = field.substr(field.indexOf(' as ') + 4);
                    }
                    let fieldAlias = d.fields[f].alias;

                    if (fields.indexOf(field) < 0) {
                        fields.push(field)
                        alias.push(fieldAlias);
                    } else {
                        if (alias[fields.indexOf(field)] === "ALIAS LU ERROR") {
                            alias[fields.indexOf(field)] = fieldAlias;
                        }

                    }
                } else {
                    let field = d.fields[f].toLowerCase();
                    if (field.indexOf(' as ') >= 0) {
                        field = field.substr(field.indexOf(' as ') + 4);
                    }

                    const fieldAlias = f >= 0 && f <= d.aliases.length ? d.aliases[f] : "ALIAS LU ERROR";

                    if (fields.indexOf(field) < 0) {
                        fields.push(field)
                        alias.push(fieldAlias);
                    } else {
                        if (alias[fields.indexOf(field)] === "ALIAS LU ERROR") {
                            alias[fields.indexOf(field)] = fieldAlias;
                        }

                    }
                }
            }
        }

        dispatch({
            type: DATA_SOURCES_ALIAS_UPDATE,
            payload: {fields: fields, aliases: alias}
        });
    }
}

export function dataViewStagedData(staged) {
    return (dispatch, getState) => {
        const state = getState();

        // Mark DS as Dirty i.e. we need to fetch '{0}staged'.format(dataSource.source)
        for (let dataSource of state.data.dataSources) {
            // Set to loading... and flag
            // so data refresh picks up
            dataSource.fetching = true;
            dataSource.fetched = false;
            dataSource.error = null;
            dataSource.cancelToken = null;
            dataSource.dirty = true;
        }

        dispatch({
            type: DATA_VIEW_STAGED,
            payload: staged
        });

        // Delay refresh in the event another change in coming in
        if (window.reloadDataSourcesID) {
            window.clearTimeout(window.reloadDataSourcesID);
        }
        window.reloadDataSourcesID = setTimeout(function () {
            dispatch(_reload());
        }, _reloadTimeout);
    }
}

export function dataReloadDependants(sources) {
    return (dispatch, getState) => {
        const state = getState();

        const dataSources = state.data.dataSources;
        for (let dataSource of dataSources) {
            if (sources.find(s => s.toLowerCase() === dataSource.source.toLowerCase())) {
                dataSource.dirty = true;
                // console.log('** DIRTY: {0} **'.format(dataSource.name));
            }
        }

        // Delay refresh in the event another change in coming in
        if (window.reloadDataSourcesID) {
            window.clearTimeout(window.reloadDataSourcesID);
        }
        window.reloadDataSourcesID = setTimeout(function () {
            dispatch(_reload());
        }, _reloadTimeout);
    }
}

export function dataReloadSources(sources) {
    return (dispatch, getState) => {
        const state = getState();

        const dataSources = state.data.dataSources;
        for (let dataSource of dataSources) {
            if (sources.find(s => s.toLowerCase() === dataSource.name.toLowerCase())) {
                dataSource.dirty = true;
                // console.log('** DIRTY: {0} **'.format(dataSource.name));
            }
        }

        // Delay refresh in the event another change in coming in
        if (window.reloadDataSourcesID) {
            window.clearTimeout(window.reloadDataSourcesID);
        }
        window.reloadDataSourcesID = setTimeout(function () {
            dispatch(_reload());
        }, _reloadTimeout);
    }
}

export function dataAddFilter(id, field, condition, action, refresh, hidden) {
    return (dispatch, getState) => {
        // console.log('dataActions:dataAddFilter(' + id  + "," + field + "," + condition + "," + action + "," + refresh + ")");

        const state = getState();
        let filters = state.data.filters;

        // TODO: Validate Inputs / Conditions
        let newField = field.toLowerCase().trim();
        let newCondition = condition.toLowerCase().trim();

        let filtersChanged = false;

        // Get the array for the input field
        let fieldInfo = filters.find(f => f.field === newField && f.id.toLowerCase() === id.toLowerCase());
        if (!fieldInfo) {
            fieldInfo = {
                id: id.toLowerCase(),
                field: field,
                conditions: [],
                hidden: hidden
            };
            filters.push(fieldInfo);
        }
        filters = Array.from(filters);

        //const existingCondition = fieldInfo.conditions.find(c => c === newCondition);
        if (action === filterUpdateConditionAction.ADD) {

            // TODO:
            fieldInfo.conditions.push(newCondition);

            filtersChanged = true;

        } else if (action === filterUpdateConditionAction.REPLACE) {

            const newConditions = [ newCondition ];

            if (fieldInfo.conditions.sort().join() !== newConditions.sort().join()){
                fieldInfo.conditions = [newCondition];
                filtersChanged = true;
            }

        }

        // console.log("filtersChanged " + filtersChanged);
        // console.log(filters);

        // Exit if there is no change
        if (!filtersChanged) {
            // console.log('** filters have not changed **');
            return;
        }

        // console.log('**FILTERS**');
        // console.log(filters);

        // NOTE: Filters are now updated after DS are flagged dirty
        // ... this allows us to compare filters, dirty, and fetched
        // when there are load dependencies... otherwise we may check
        // and see the filter is there but the data is updated
        // with a previous call (failed cancel)
        // // Persist Filters
        // dispatch({
        //     type: DATA_SOURCES_FILTER_UPDATE,
        //     payload: {
        //         id: id,
        //         filters: filters,
        //         previousFilters: []
        //     }
        // });

        dispatch(_updateAffectedDataSources(refresh, filters, []));
    }
}

// NOTE: This process has to morph to handle
// changing requirements and uses of the API
export function dataRemoveFilter(id) {
    return (dispatch, getState) => {
        const state = getState();

        // console.log('dataActions:removeDataFilter({0}) at {1}'.format(id, new Date()));

        // Remove the requested filters
        let previousFilters = state.data.filters;

        const newFilters = state.data.filters.filter(function (f) {
            return f.id.toString().toLowerCase() !== id.toString().toLowerCase();
        });

        console.log('**FILTERS**');
        console.log(newFilters);

        // No need to refresh if we haven't changed the conditions
        if (newFilters.length === previousFilters.length) {
            return;
        }

        // NOTE: Filters are now updated after DS are flagged dirty
        // ... this allows us to compare filters, dirty, and fetched
        // when there are load dependencies... otherwise we may check
        // and see the filter is there but the data is updated
        // with a previous call (failed cancel)

        // // Add the remaining filters
        // dispatch({
        //     type: DATA_SOURCES_FILTER_UPDATE,
        //     payload: {
        //         filters: newFilters,
        //         previousFilters: previousFilters,
        //         id: null
        //     }
        // });

        dispatch(_updateAffectedDataSources(true, newFilters, previousFilters));
    }
}

export function dataRemoveAllFilters() {
    return (dispatch, getState) => {
        const state = getState();

        // Remove all but the default -2112 filters
        let previousFilters = state.data.filters;
        const newFilters = state.data.filters.filter(function (f) {
            return f.id === "-2112";
        });

        // NOTE: Filters are now updated after DS are flagged dirty
        // ... this allows us to compare filters, dirty, and fetched
        // when there are load dependancies... otherwise we may check
        // and see the filter is there but the data is updated
        // with a previous call (failed cancel)

        // dispatch({
        //     type: DATA_SOURCES_FILTER_UPDATE,
        //     payload: {
        //         filters: newFilters,
        //         previousFilters: previousFilters,
        //         id: null
        //     }
        // });

        dispatch(_updateAffectedDataSources(true, newFilters, previousFilters));
    }
}

// Persist the Portfolio top row filter values as the app is filtered
export function dataSetPortfolioFilterVals(distinctVals) {
    return {
        type: DATA_PORTFOLIO_FILTER_VALUES,
        payload: distinctVals
    };
}

// Persist the selected projects across the app
export function dataSetSelectedProjectVals(selectedProjects) {
    return {
        type: DATA_SELECTED_PROJECTS_VALUE,
        payload: selectedProjects
    };
}

export function dataSetDataDate(dataDate) {
    return {
        type: DATA_DATA_DATE,
        payload: dataDate
    }
}

function _update(dataSource) {
    return (dispatch, getState) => {
        const state = getState();

        const dataSources = state.data.dataSources;

        // for (let i = 0; i < dataSources.length; i++) {
        //     const s = dataSources[i];
        //     if (s.name === dataSource.name) {
        //         dataSources[i] = {
        //             ...dataSource
        //         };
        //     }
        // }

        // Note - the array as to change for hooks to
        // determine change
        const updatedDataSources = dataSources.map(s => {
            if (s.name === dataSource.name) {
                return dataSource;
            } else {
                return s;
            }
        });

        dispatch({
            type: DATA_SOURCES_UPDATE,
            payload: updatedDataSources
        });
    }
}

function _updateAffectedDataSources(refresh, filters, previousFilters) {
    return (dispatch, getState) => {
        const state = getState();
        // console.log('dataActions:_updateAffectedDataSources()');

        // NOTE: We no longer need to consider previous filters
        // as there is a dual check - is a condition met OR
        // was there a condition that has been removed
        const allFilters = filters.concat(previousFilters);
        //const allFilters = filters;

        const updatedSources = state.data.dataSources.map(dataSource => {
            let isAffected = false;
            if (dataSource.listeners.length > 0) {
                for (let f = 0; f < allFilters.length; f++) {
                    const filter = allFilters[f];
                    // if (filter.id === -2112 && !skipDefaultFilters) {

                        // Determine if the filters that affect have changed i.e.
                        // if an existing filter of GID = 1 and then you add PM = Todd then anything
                        // listening to GID will update even if they don't care about TODD
                        const field = filter.field;
                        let existingFilterIndex = -2112;
                        if (dataSource.listeners.find(f => f.toLowerCase() === field.toLowerCase())) {
                            // We have a listener hit BUT did the value change? If not then there
                            // is no change to the DS
                            const existingFitlerState = dataSource.filterState.find((fs, i) => {
                                // Is this our field
                                if (fs.length > filter.field.length && fs.substring(0, filter.field.length) === filter.field) {
                                    existingFilterIndex = i;
                                    return true;
                                }
                            });
                            const newFilterState = "{0}:{1}".format(filter.field, filter.conditions.join());

                            if (newFilterState !== existingFitlerState) {
                                // Note that an existing filter or a new filter
                                // affects this dataSource
                                isAffected = true
                            }

                            // if (dataSource.name === "vwAdvPortfolioSpreadSummary") {
                            //     console.log('-------------------');
                            //     console.log(existingFitlerState);
                            //     console.log(newFilterState);
                            //     console.log(isAffected);
                            // }

                            // Remove existing state
                            if (existingFilterIndex !== -2112) {
                                dataSource.filterState.splice(existingFilterIndex, 1);
                            }

                            // Store new state for this field
                            dataSource.filterState.push("{0}:{1}".format(filter.field, filter.conditions.join()));

                        }

                    // }
                }

                // Was a filter removed not triggering the isAffected i.e.
                // is there a persisted state for a filter that doesn't
                // exist and if so we need to refresh
                for (let f = dataSource.filterState.length - 1; f >= 0; f--) {
                    const stateField = dataSource.filterState[f].substring(0, dataSource.filterState[f].indexOf(":"));

                    const filterMatch = filters.find(f => f.field === stateField);
                    if (!filterMatch) {
                        dataSource.filterState.splice(f, 1);
                        isAffected = true;
                    }
                }
            }

            if (isAffected) {
                // Cancel existing token
                const cancelToken = dataSource.cancelToken;
                if (cancelToken) {
                    cancelToken.cancel('{0} Fetch Operation Cancelled'.format(dataSource.source));
                }
                if (dataSource.uid) {
                    window.dw.utils.cancelledDSID.push(dataSource.uid);
                }

                // Set to loading... and flag
                // so data refresh picks up
                dataSource.fetching = true;
                dataSource.fetched = false;
                dataSource.error = null;
                dataSource.dirty = true;

                // console.log(dataSource.name + ' ----- DIRTY --------> ' + dataSource.dirty + ' --- BULK ---> ' + dataSource.includeInBulkRequest);
            }

            return dataSource;
        });

        // Update array
        dispatch({
            type: DATA_SOURCES_UPDATE,
            payload: updatedSources
        });

        // Now that data sources are marked dirty
        // fire filter changed
        // const clonedFilters = filters.map(filter => { return filter });
        dispatch({
            type: DATA_SOURCES_FILTER_UPDATE,
            payload: {
                filters: filters,
                previousFilters: previousFilters
            }
        });

        // Update Data Sources if requested... otherwise don't change
        // state as a subsequent call will
        if (refresh) {

            // Delay refresh in the event another change in coming in
            if (window.reloadDataSourcesID) {
                window.clearTimeout(window.reloadDataSourcesID);
            }
            window.reloadDataSourcesID = setTimeout(function () {
                dispatch(_reload());
            }, _reloadTimeout);
        }
    }
}

function _filterButtonHook(dataSource) {
    // NOTE: We will want to add a null rendering component to packages
    // to handle app level events before the package layout is rendered
    // TODO: Implement later
    return (dispatch, getState) => {
        const state = getState();

        if (dataSource.name === 'portfolio') {
            // // If the store has not yet been filled, fill it!
            // if (state.data.dataPortfolioFilterVals.length === 0) {
            //
            //     const pages = state.page.pages;
            //     const portfolioConfig = pages.find(page => page.name === "portfolio");
            //     const cardFilterField = portfolioConfig.cardFilters.filterField;
            //
            //     let distinctVals = [...new Set(dataSource.data.map(item => item[cardFilterField]))].sort();
            //     dispatch(dataSetPortfolioFilterVals(distinctVals));
            // }
        }
    }
}

function _getAPIUrl(config, dataSource, filters, excludeID, staged) {

    let whereClause = '';
    if (dataSource.listeners.length > 0) {
        for (let f of filters) {
            if (excludeID === null || f.id !== excludeID) {
				const isAffected = dataSource.listeners.find(l => l === f.field);

                if (isAffected) {
                    for (let c of f.conditions) {
                        whereClause += '{0} {1} AND '.format(f.field, c);
                    }
                }
            }
        }
        if (whereClause.length > 0) {
            whereClause = whereClause.substr(0, whereClause.length - 5);
        }
    }

    const target = dataSource.enhanced ? "ev" : "table";

    const fieldNames = dataSource.fields.map(f => typeof f === "object" ? f.name : f);
    const fields = dataSource.fields.length > 0 ? '&fields={0}'.format(fieldNames.join(',')) : '';

    const groupBy = dataSource.groupby.length > 0 ? '&groupby={0}'.format(dataSource.groupby.join(',')) : '';
    const orderBy = dataSource.orderby.length > 0 ? '&orderby={0}'.format(dataSource.orderby.join(',')) : '';
    whereClause = whereClause.length > 0 ? '&where={0}'.format(encodeURIComponent(whereClause)) : '';
    const source = staged ? '{0}staged'.format(dataSource.source) : dataSource.source;

    const apiUrl = "https://synthetic/DBQuery?{0}={1}{2}&db={3}{4}{5}{6}".format(target, source, fields, config.authentication.apiSource, whereClause, groupBy, orderBy);

    return apiUrl;
}

// NOTE: Here were looking to do two things...
// 1) pass multiple queries in the
// body of the request to reduce the number of database calls
// 2) pass variations of the query to satisfy data highlighting
// i.e. all data without a components condition so the component
// can highlight the results not determine the results
function _reload() {
    return (dispatch, getState) => {
        const state = getState();

        // console.log('*********************_reload()*********************');

        // const router = state.router;
        const pathname = state.router.location.pathname;
        const config = state.config.data;
		const pages = state.page.pages;
        const dataSources = state.data.dataSources;
        const activeRoleName = state.persist.activeRoleName ? state.persist.activeRoleName : null;

        // Exit if app is not initialized
        if (!config)
            return;

		if (!pages)
			return;

        const routeInfo = getRouteInfo(pathname, pages, activeRoleName);
        if (routeInfo.activeRoute === null)
            return;

        // Exit if no dataSources are dirty
        if (dataSources.filter((d) => {
            if (d.dirty === true
                && d.routes.filter((r) => { if (r.length <= routeInfo.activeRoute.length && r === routeInfo.activeRoute.substring(0, r.length)) return true; }).length > 0
                //&& d.routes.find((r) => { if (r.length <= routeInfo.activeRoute.length && r === routeInfo.activeRoute.substring(0, r.length)) return true; })
                && d.roles.includes(activeRoleName)) {
                return true;
            }
            else {
                return false;
            }
        }).length === 0) {
            console.log("Exiting reload, All route configured data sources are clean for route:'{0}'/role:{1}".format(routeInfo.activeRoute, activeRoleName));
            return;
        }

        // Cancel existing BATCH request
        const cancelToken = state.data.cancelToken;
        if (cancelToken) {
            cancelToken.cancel('Bulk Fetch Operation Cancelled'.format());
        }

        // TODO: Cancel existing batch...
        const batchPostBody = {
            dataSources: []
        };

        for (let dataSource of dataSources) {
            if (!dataSource.includeInBulkRequest) {
                if (dataSource.dirty && (!dataSource.routes || dataSource.routes.filter((r) => { if (r.length <= routeInfo.activeRoute.length && r === routeInfo.activeRoute.substring(0, r.length)) return true; }).length > 0) && (!dataSource.roles || dataSource?.roles?.includes(activeRoleName))) {

                    // console.log(dataSource.routes.join(',') + " includes " + routeInfo.activeRoute);

                    // Cancel existing token
                    const cancelToken = dataSource.cancelToken;
                    if (cancelToken) {
                        cancelToken.cancel('{0} Fetch Operation Cancelled'.format(dataSource.name));
                    }
                    if (dataSource.uid) {
                        window.dw.utils.cancelledDSID.push(dataSource.uid);
                    }

                    // Get new cancel token and persist it
                    dataSource.cancelToken = axios.CancelToken.source();
                    // Setup a new UID to track
                    dataSource.uid = window.dw.utils.newDSID();
                    dataSource.fetching = true;
                    dataSource.fetched = false;
                    dataSource.loadCount = dataSource.loadCount += 1;

                    dispatch(_update(dataSource));

                    const postBody = {
                        dataSources: []
                    };

                    const dataSourceRequest = {
                        name: dataSource.name,
                        uid: dataSource.uid,
                        request: _getAPIUrl(config, dataSource, state.data.filters, null, state.data.viewStaged),
                        baselines: []
                    };

                    // Get the unique ids of each filter and build requests
                    // that exclude each unique component ID - this will provide
                    // unfiltered baselines that components can highlight
                    if (dataSource.includeBaselineResults) {
                        const baselineFilterIDs = Array.from(new Set(state.data.filters.map(f => f.id)));
                        for (let id of baselineFilterIDs) {
                            // Skip core defaults
                            //if (id !== "-2112" && dataSource.listeners.length > 0) {
                            dataSourceRequest.baselines.push({
                                id: id,
                                request: _getAPIUrl(config, dataSource, state.data.filters, id, state.data.viewStaged)
                            });
                            //}
                        }
                    }

                    // console.log(dataSourceRequest);
                    postBody.dataSources.push(dataSourceRequest);

                    const futureCaching = false;
                    if (postBody.dataSources.length === 1 && !dataSource.enhanced && futureCaching === true) { // && postBody.dataSources[0].name === 'vwAdvPortfolioProjPager') {
                        // NOTE: axiosCached does not support posts so we could split
                        // DS with no baseline to a get or use promises to cache everything
                        // axiosCached.post(config.authentication.api + 'DBQuery?db={0}&ref={1}'.format(config.authentication.apiSource, dataSource.name, dataSource.loadCount), postBody, {headers: {'Authorization': 'Bearer ' + tokenResponse.accessToken}})
                        const getRequest = "{0}DBQuery?{1}".format(config.authentication.api, postBody.dataSources[0].request.substring(26));
                        console.log('Using cache for {0} sourced to {1}'.format(dataSource.name, dataSource.source));
                        axiosCached.get(getRequest)
                            .then(function (response) {
                                //console.log('response', response);

                                // console.log('** Updating dataSource.data for {0} **'.format(dataSource.name));
                                dataSource.data = response.data;
                                dataSource.baselines = [];
                                dataSource.fetching = false;
                                dataSource.fetched = true;
                                dataSource.error = null;
                                dataSource.cancelToken = null;
                                dataSource.dirty = false;

                                dispatch(_update(dataSource));

                            }).catch(function (error) {
                                console.log('**ERROR**', error);

                                dataSource.data = [];
                                dataSource.baselines = null;
                                dataSource.fetching = false;
                                dataSource.fetched = true;
                                dataSource.error = error;
                                dataSource.cancelToken = null;
                                dataSource.dirty = false;

                                dispatch(_update(dataSource));
                        });
                    } else
                    {
                        if (dataSource.requireWhereClause && dataSourceRequest.request.indexOf("where=") === -1) {
                            // In this instance we null out data i.e. we only want
                            // data when a specific GID/listener/where has been applied
                            dataSource.data = [];
                            dataSource.baselines = [];
                            dataSource.fetching = false;
                            dataSource.fetched = true;
                            dataSource.error = null;
                            dataSource.cancelToken = null;
                            dataSource.dirty = false;

                            dispatch(_update(dataSource));
                        }
                        else {
                            // NOTE: axiosCached does not support posts so we could split
                            // DS with no baseline to a get or use promises to cache everything
                            // axiosCached.post(config.authentication.api + 'DBQuery?db={0}&ref={1}'.format(config.authentication.apiSource, dataSource.name, dataSource.loadCount), postBody, {headers: {'Authorization': 'Bearer ' + tokenResponse.accessToken}})
                            axios.post(config.authentication.api + 'DBQuery?db={0}&ref={1}&lc={2}'.format(config.authentication.apiSource, dataSource.name, dataSource.loadCount), postBody)
                                .then(function (response) {
                                    // console.log('response', response.data.dataSources);
                                    // Post up the results
                                    for (let d = 0; d < response.data.dataSources.length; d++) {
                                        const name = response.data.dataSources[d].name;
                                        const uid = response.data.dataSources[d].uid;
                                        const result = response.data.dataSources[d].result;

                                        // if (name === "vwAdvActivitySpreadPIL" || name === "vwAdvActivitySpreadPILSummary") {
                                        //     console.log('-----------------');
                                        //     console.log(name);
                                        //     console.log(result);
                                        //     console.log('-----------------');
                                        //     return ;
                                        // }

                                        // TODO decodeURIComponent on Baselines Request
                                        const baselines = response.data.dataSources[d].baselines;

                                        const dataSource = state.data.dataSources.find(d => {
                                            return d.name === name
                                        });

                                        if (window.dw.utils.cancelledDSID.includes(uid)) {
                                            // console.log('-- Results returned for DataSource {0} but are being ignored bc the original call was cancelled --'.format(dataSource.name));
                                            return;
                                        }

                                        // if (dataSource.name === "vwAdvPortfolioSpreadSummary" || dataSource.name === "vwAdvPortfolioHierarchy") {
                                        //     console.log(result);
                                        // }

                                        // console.log('** Updating dataSource.data for {0} **'.format(dataSource.name));
                                        dataSource.data = result;
                                        dataSource.baselines = baselines;
                                        dataSource.fetching = false;
                                        dataSource.fetched = true;
                                        dataSource.error = null;
                                        dataSource.cancelToken = null;
                                        dataSource.dirty = false;

                                        // if (dataSource.name === 'portfolio') {
                                        //     dispatch(_filterButtonHook(dataSource));
                                        // }
                                        dispatch(_update(dataSource));
                                    }

                                }).catch(function (error) {
                                    console.log('**ERROR**', error);

                                    dataSource.data = [];
                                    dataSource.baselines = null;
                                    dataSource.fetching = false;
                                    dataSource.fetched = true;
                                    dataSource.error = error;
                                    dataSource.cancelToken = null;
                                    dataSource.dirty = false;

                                    dispatch(_update(dataSource));
                            });
                        }
                    }
                }
                // else if (dataSource.dirty) {
                //     console.log('**WARN** Skipping dirty source "{0}" as it is not tied to this route:{1}/role:{2}'.format(dataSource.name, routeInfo.activeRoute, activeRoleName));
                // }
            } else {

                // Build out Bulk Request
                if (dataSource.dirty && (!dataSource.routes || dataSource.routes.find(r => (r.length <= routeInfo.activeRoute.length && routeInfo.activeRoute.substring(0, r.length) === r))) && (!dataSource.roles || dataSource?.roles?.includes(activeRoleName))) {

                    if (dataSource.uid) {
                        window.dw.utils.cancelledDSID.push(dataSource.uid);
                    }

                    // Set DS To Loading...
                    dataSource.loadCount = dataSource.loadCount += 1;
                    dataSource.fetching = true;
                    dataSource.fetched = false;
                    // Setup a new UID to track
                    dataSource.uid = window.dw.utils.newDSID();
                    dispatch(_update(dataSource));

                    const dataSourceRequest = {
                        name: dataSource.name,
                        uid: dataSource.uid,
                        request: _getAPIUrl(config, dataSource, state.data.filters, null, state.data.viewStaged),
                        baselines: []
                    };

                    // Get the unique ids of each filter and build requests
                    // that exclude each unique component ID - this will provide
                    // unfiltered baselines that components can highlight
                    if (dataSource.includeBaselineResults) {
                        const baselineFilterIDs = Array.from(new Set(state.data.filters.map(f => f.id)));
                        for (let id of baselineFilterIDs) {
                            // Skip core defaults
                            // if (id !== "-2112" && dataSource.listeners.length > 0) {
                                dataSourceRequest.baselines.push({
                                    id: id,
                                    request: _getAPIUrl(config, dataSource, state.data.filters, id, state.data.viewStaged)
                                });
                            // }
                        }
                    }

                    batchPostBody.dataSources.push(dataSourceRequest);
                }
                // else if (dataSource.dirty) {
                //     console.log('**WARN** Skipping dirty source "{0}" as it is not tied to this route:{1}/role:{2}'.format(dataSource.name, routeInfo.activeRoute, roleName));
                // }
            }
        }

        // Post Bulk Request
        if (batchPostBody.dataSources.length > 0) {
            setTimeout(function () {

                // Store a new cancel token for BATCH and persist it
                dispatch({
                    type: DATA_SOURCES_CANCEL_TOKEN,
                    payload: axios.CancelToken.source()
                });

                if (batchPostBody.dataSources.length > 0) {

                    axios.post(config.authentication.api + 'DBQuery?db={0}&ref=bulk'.format(config.authentication.apiSource), batchPostBody)
                        .then(function (response) {

                            // Post up the results
                            for (let d = 0; d < response.data.dataSources.length; d++) {
                                const name = response.data.dataSources[d].name;
                                const uid = response.data.dataSources[d].uid;
                                const result = response.data.dataSources[d].result;

                                // console.log('-- Results returned for {0} --'.format(name));

                                // TODO decodeURIComponent on Baselines Request
                                const baselines = response.data.dataSources[d].baselines;

                                const dataSource = state.data.dataSources.find(d => {
                                    return d.name === name
                                });

                                if (window.dw.utils.cancelledDSID.includes(uid)) {
                                    console.log('-- BulkRequest: Results returned for DataSource {0} but are being ignored bc the original call was cancelled --'.format(dataSource.name));
                                    return;
                                }

                                dataSource.data = result;
                                dataSource.baselines = baselines;
                                dataSource.fetching = false;
                                dataSource.fetched = true;
                                dataSource.error = null;
                                dataSource.cancelToken = null;
                                dataSource.dirty = false;

                                if (dataSource.name === 'portfolio') {
                                    dispatch(_filterButtonHook(dataSource));
                                }
                                dispatch(_update(dataSource));
                            }

                        }).catch(function (error) {
                        console.log('**ERROR**', error);

                        // Post up the results
                        for (let dataSource of dataSources) {
                            if (dataSource.includeInBulkRequest) {

                                const uid = dataSource.uid;

                                dataSource.data = [];
                                dataSource.baselines = null;
                                dataSource.fetching = false;
                                dataSource.fetched = true;
                                dataSource.error = error;
                                dataSource.cancelToken = null;
                                dataSource.dirty = false;

                                // dispatch(_update(dataSource));
                            }
                        }
                    });
                }

            }, JSON.parse(axiosDelay()));
        }

    }
}
